import React from 'react'
import classNames from 'classnames'
import useUrlParams from 'hooks/useUrlParams'

function FacetChipButton({ facet }) {
  const { urlParams, updateUrlParams } = useUrlParams()

  const handlePick = ({ id, displayName }) => {
    const value = urlParams[id] ? undefined : displayName
    updateUrlParams({ [id]: value })
  }

  // NOTE: all inline styling would be better off in the global Drupal styling
  return (
    <div className="column u-max-width-full u-mt-150 u-mt-200-large-up" style={{ flex: '0 0 200px' }}> {/* NOTE: fixed width for all filters */}
      <div className="u-max-width-full u-text-uppercase u-mb-50 label u-text-uppercase u-mb-50">
        { facet.displayName }
      </div>
      {facet.filters.map(filter => (
        <button
          className={classNames('chip', { 'is-active': urlParams[facet.id] === filter.displayName })}
          aria-label={filter.displayName}
          onClick={() => handlePick({ id: facet.id, ...filter })}
          style={{
            backgroundColor: urlParams[facet.id] ? '' : '#fff',
          }}
        >
          <div className="chip__text" style={{ whiteSpace: 'nowrap' }}> {/* NOTE: needs to be addressed when switching from fixed width above */}
            { filter.displayName }
            { ' ' }
            <span style={{ color: 'grey', fontWeight: 400 }}>
              ({ filter.count })
            </span>
          </div>
        </button>
      ))}
    </div>
  )
}

export default FacetChipButton
